import Vue from 'vue'
import {mapGetters} from 'vuex'
import MapMixin from 'js/mixins/map.js'
import {
  stepMarker, destinyMarker, userPositionMarker, stepIconName, stepTitle, stepColor, TRAVEL_MODES
} from 'js/lib/planner'
import popupTemplate from './popup.pug'
import template from './_planner-map.pug'

const DASH_WALKING_CONFIG = '8, 16'

export default Vue.extend({
  template: template(),

  mixins: [MapMixin],

  props: {
    route: {
      type: Object,
      default: null
    },

    userPosition: {
      type: Object,
      default: null
    },

    sidePanelOpen: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters(['mapEngine']),

    userPositionMarker() {
      return userPositionMarker
    },

    stepMarker() {
      return stepMarker
    },

    destinyMarker() {
      return destinyMarker
    },

    steps() {
      return _.get(this.route, 'leg.steps') || []
    },

    lastStep() {
      const stepsLength = this.steps.length
      return stepsLength ? this.steps[stepsLength - 1] : null
    }
  },

  watch: {
    route(newRoute) {
      if (newRoute) {
        const bounds = L.latLngBounds(newRoute.polyline.geometry.coordinates)
        this.map.fitBounds(bounds)
      }
    },

    sidePanelOpen() {
      setTimeout(() => this.map.invalidateSize(true), 250)
    }
  },

  methods: {
    createStepPopup(step) {
      const popupData = {
        name: stepTitle(step),
        iconName: stepIconName(step),
        iconColor: stepColor(step, {acceptWhite: false})
      }

      const popup = L.popup({className: 'planner-popup'})

      return popup.setContent(popupTemplate(popupData))
    },

    polylineStyleFunction(step) {
      const color = stepColor(step, {acceptWhite: false})
      const dashArray = step.travel_mode === TRAVEL_MODES.WALKING ? DASH_WALKING_CONFIG : false

      return () => ({
        color,
        dashArray,
        weight: 3,
        lineCap: 'square'
      })
    },

    generateEachFeatureCallback(step) {
      return this.bindPolylinePopup.bind(this, step)
    },

    bindPolylinePopup(step, feature, layer) {
      const popup = this.createStepPopup(step)
      layer.bindPopup(popup)
    }
  }
})
